const syllabusButton = document.querySelector('#openSyllabusPanelButton');
const syllabusPanel = document.querySelector('.sidebar-scroll');
const currentAssignmentItem = document.querySelector(
  '#current-assignment-item',
);

document.addEventListener('DOMContentLoaded', () => {
  if (!currentAssignmentItem) {
    return;
  }

  const elementTop = currentAssignmentItem.getBoundingClientRect().top;
  const heightOfViewport = window.innerHeight;
  let scrollDistance;

  if (syllabusButton) {
    syllabusButton.addEventListener('click', () => {
      // 350 milliseconds for letting the syllabus panel to fully open and its width to exceed 450px
      setTimeout(() => {
        if (syllabusPanel.getBoundingClientRect().width > 450) {
          scrollDistance = elementTop / 3 - heightOfViewport / 3;
        } else if (
          syllabusPanel.getBoundingClientRect().width > 390 &&
          syllabusPanel.getBoundingClientRect().width < 450
        ) {
          scrollDistance = elementTop / 2 - heightOfViewport;
        } else if (syllabusPanel.getBoundingClientRect().width < 390) {
          scrollDistance = elementTop / 2;
        }

        syllabusPanel.scrollTo({
          top: scrollDistance,
          behavior: 'smooth',
        });
      }, 350);
    });
  }
});
